import React from 'react';
import Line from './Line';

const CommissionText = () => (
    <Line className="commissionText">
        If you click on a link on this site which takes you to a bookmaker
        or casino and you subsequently open an account, Racingpost may receive a commission.
    </Line>
);

export default CommissionText;



// WEBPACK FOOTER //
// /src/js/common/gamblingCompliance/components/CommissionText.jsx